import styled from "styled-components";

const NavItem = styled.li`
  transition: background-color 240ms ease-in;
`;

export default NavItem;
